// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Typography,
//   Checkbox,
//   IconButton,
//   Button,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { Refresh as RefreshIcon } from "@mui/icons-material";
// import axios from "axios";
// import swal from "sweetalert";


// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 600,
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.selected,
//   },
//   transition: "background-color 0.3s",
// }));

// function AdminSelected() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const rowsPerPage = 5;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   useEffect(() => {
//     filterData();
//   }, [data]);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const filterData = () => {
//     const filtered = data.filter((row) => row.admin_approval === false); // Show only not-shortlisted projects
//     setFilteredData(filtered);
//   };

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowSelect = (stud_id) => {
//     // Allow only one selection at a time
//     setSelectedRows(selectedRows.includes(stud_id) ? [] : [stud_id]);
//   };
//   // const handleShortlist = async () => {
//   //   if (selectedRows.length === 0) {
//   //     swal("No Selection!", "Please select at least one project to shortlist.", "info");
//   //     return;
//   //   }
  
//   //   try {
//   //     const payload = {
//   //       stud_id: selectedRows,
//   //     };
  
//   //     const response = await axios.patch(
//   //       "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//   //       payload
//   //     );
  
//   //     // Display success message using SweetAlert
//   //     swal("Success!", response.data.msg, "success");
  
//   //     // Update the UI to remove shortlisted rows
//   //     setData((prevData) =>
//   //       prevData.map((item) =>
//   //         selectedRows.includes(item.stud_id)
//   //           ? { ...item, admin_approval: true }
//   //           : item
//   //       )
//   //     );
  
//   //     setFilteredData((prevFilteredData) =>
//   //       prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//   //     );
  
//   //     setSelectedRows([]);
//   //   } catch (error) {
//   //     console.error("Error shortlisting projects:", error);
  
//   //     // Display error message using SweetAlert
//   //     swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//   //   }
//   // };
  
//   // const handleShortlist = async () => {
//   //   try {
//   //     const response = await axios.patch(
//   //       "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//   //       { stud_id: selectedRows }
//   //     );
  
//   //     // Display success message using SweetAlert
//   //     swal("Success!", response.data.msg, "success");
  
//   //     // Update the UI to remove shortlisted rows
//   //     setData((prevData) =>
//   //       prevData.map((item) =>
//   //         selectedRows.includes(item.stud_id)
//   //           ? { ...item, admin_approval: true }
//   //           : item
//   //       )
//   //     );
  
//   //     setFilteredData((prevFilteredData) =>
//   //       prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//   //     );
  
//   //     setSelectedRows([]);
//   //   } catch (error) {
//   //     console.error("Error shortlisting projects:", error);
  
//   //     // Display error message using SweetAlert
//   //     swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//   //   }
//   // };
//   // const handleShortlist = async () => {
//   //   try {
//   //     const response = await axios.patch(
//   //       "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//   //       { stud_id: selectedRows }
//   //     );
  
//   //     alert(response.data.msg);
  
//   //     // Remove shortlisted rows from the filtered data
//   //     setData((prevData) =>
//   //       prevData.map((item) =>
//   //         selectedRows.includes(item.stud_id)
//   //           ? { ...item, admin_approval: true }
//   //           : item
//   //       )
//   //     );
  
//   //     setFilteredData((prevFilteredData) =>
//   //       prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//   //     );
  
//   //     setSelectedRows([]);
//   //   } catch (error) {
//   //     console.error("Error shortlisting projects:", error);
//   //     alert("Failed to shortlist projects. Please try again.");
//   //   }
//   // };
  
//   // const handleShortlist = async () => {
//   //   try {
//   //     for (const stud_id of selectedRows) {
//   //       await axios.patch("https://puneexpobackend.tdtlworld.com/api/approve_project/", {
//   //         stud_id,
//   //       });
//   //       // Update the data to mark as shortlisted
//   //       setData((prevData) =>
//   //         prevData.map((item) =>
//   //           item.stud_id === stud_id ? { ...item, admin_approval: true } : item
//   //         )
//   //       );
//   //     }
//   //     alert("Selected project has been shortlisted successfully.");
//   //     setSelectedRows([]);
//   //   } catch (error) {
//   //     console.error("Error shortlisting projects:", error);
//   //     alert("Failed to shortlist project. Please try again.");
//   //   }
//   // };
//   const handleShortlist = async () => {
//     try {
//       // Send only stud_id as an array in the payload
//       const response = await axios.patch(
//         "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//         { stud_id: selectedRows } // selectedRows should only contain stud_id values
//       );
  
//       // Display success message using SweetAlert
//       swal("Success!", response.data.msg, "success");
  
//       // Update the UI to remove shortlisted rows
//       setData((prevData) =>
//         prevData.map((item) =>
//           selectedRows.includes(item.stud_id)
//             ? { ...item, admin_approval: true }
//             : item
//         )
//       );
  
//       setFilteredData((prevFilteredData) =>
//         prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//       );
  
//       setSelectedRows([]); // Clear selected rows
//     } catch (error) {
//       console.error("Error shortlisting projects:", error);
  
//       // Display error message using SweetAlert
//       swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//     }
//   };
  
//   const renderTable = () => {
//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

//     return (
//       <TableBody>
//         {currentData.map((row, index) => (
//           <StyledTableRow key={row.stud_id}>
//             <TableCell padding="checkbox">
//               <Checkbox
//                 checked={selectedRows.includes(row.stud_id)}
//                 onChange={() => handleRowSelect(row.stud_id)}
//               />
//             </TableCell>
//             <TableCell>{startIndex + index + 1}</TableCell>
//             <TableCell>{row.title}</TableCell>
//             <TableCell>{row.description}</TableCell>
//             <TableCell>{row.project_type}</TableCell>
//             <TableCell>{new Date(row.created_at).toLocaleDateString()}</TableCell>
//             <TableCell align="center">
//               {row.idea ? (
//                 <a href={row.idea} target="_blank" rel="noopener noreferrer">
//                   View Idea
//                 </a>
//               ) : (
//                 "No Idea"
//               )}
//             </TableCell>
//           </StyledTableRow>
//         ))}
//       </TableBody>
//     );
//   };

//   return (
//     <Box sx={{ margin: "70px", padding: "20px", textAlign: "center" }}>
//        <Typography
//         variant="h4"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           color: "#37474f",
//           textAlign: "center",
//         }}
//       >
// Shortlisting Projects      </Typography>

//       <Box sx={{ marginBottom: "20px", display: "flex", justifyContent: "space-between" }}>
//         <IconButton onClick={fetchData} color="primary">
//           <RefreshIcon />
//         </IconButton>
//       </Box>

//       <TableContainer
//         component={Paper}
//         sx={{
//           maxWidth: "1000px",
//           margin: "0 auto",
//           backgroundColor: "#E8F4FA",
//           borderRadius: "16px",
//           overflow: "hidden",
//         }}
//       >
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell padding="checkbox">
//                 <Checkbox
//                   checked={false}
//                   disabled
//                 />
//               </StyledTableCell>
//               <StyledTableCell>Sr. No.</StyledTableCell>
//               <StyledTableCell>Title</StyledTableCell>
//               <StyledTableCell>Description</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               <StyledTableCell>Created At</StyledTableCell>
//               <StyledTableCell align="center">Idea</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           {renderTable()}
//         </Table>
//       </TableContainer>

//       <Box sx={{ margin: "20px auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <Pagination
//           count={Math.ceil(filteredData.length / rowsPerPage)}
//           page={currentPage}
//           onChange={handlePageChange}
//           color="primary"
//           size="large"
//         />
//         <Button
//           variant="contained"
//           color="success"
//           onClick={handleShortlist}
//           disabled={selectedRows.length === 0}
//         >
//           Shortlist Selected
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default AdminSelected;

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Typography,
//   Checkbox,
//   IconButton,
//   Button,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { Refresh as RefreshIcon } from "@mui/icons-material";
// import axios from "axios";
// import swal from "sweetalert";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 600,
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.selected,
//   },
//   transition: "background-color 0.3s",
// }));

// function AdminSelected() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const rowsPerPage = 5;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const filterData = useCallback(() => {
//     const filtered = data.filter((row) => row.admin_approval === false);
//     setFilteredData(filtered);
//   }, [data]);

//   useEffect(() => {
//     filterData();
//   }, [filterData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowSelect = (stud_id) => {
//     setSelectedRows((prev) =>
//       prev.includes(stud_id)
//         ? prev.filter((id) => id !== stud_id)
//         : [...prev, stud_id]
//     );
//   };

//   const handleShortlist = async () => {
//     try {
//       const response = await axios.patch(
//         "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//         { stud_id: selectedRows }
//       );

//       swal("Success!", response.data.msg, "success");

//       setData((prevData) =>
//         prevData.map((item) =>
//           selectedRows.includes(item.stud_id)
//             ? { ...item, admin_approval: true }
//             : item
//         )
//       );

//       setFilteredData((prevFilteredData) =>
//         prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//       );

//       setSelectedRows([]);
//     } catch (error) {
//       console.error("Error shortlisting projects:", error);
//       swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//     }
//   };

//   const handleDownloadExcel = () => {
//     const excelData = filteredData.map((item, index) => ({
//       "Sr. No": index + 1,
//       "Project Title": item.title,
//       "Description": item.description,
//       "Project Type": item.project_type,
//       "Student Name": item.stud_id?.full_name || "N/A",
//       Email: item.stud_id?.email || "N/A", // Fetch email from stud_id
//       "Institute": item.stud_id?.institution || "N/A",
//       "Group Name": item.name_of_group || "N/A",
//       "Group Members": item.number_of_member || "Single",
//       "PDF Link": item.idea
//         ? { t: "s", v: "View PDF", l: { Target: item.idea } }
//         : "No Idea",
//       "PPT Link": item.ppt
//         ? { t: "s", v: "View PPT", l: { Target: item.ppt } }
//         : "Not Available",
//       "Video Link": item.video_file
//         ? { t: "s", v: "View Video", l: { Target: item.video_file } }
//         : "Not Available",
//     }));
  
//     // Create worksheet and workbook
//     const worksheet = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_aoa(
//       worksheet,
//       [Object.keys(excelData[0])],
//       { origin: "A1" }
//     );
  
//     // Add rows with hyperlinks
//     XLSX.utils.sheet_add_json(worksheet, excelData, {
//       origin: "A2",
//       skipHeader: true,
//     });
  
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
  
//     // Write the workbook to a file
//     XLSX.writeFile(workbook, "Projects.xlsx");
//   };
  
  
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();

//     doc.text("Projects List", 14, 10);
//     autoTable(doc, {
//       head: [
//         [
//           "Sr. No.",
//           "Project Title",
//           "Description",
//           "Project Type",
//           "Student Name",
//           "Institute",
//           "Group Name",
//           "Group Members",
//           "PDF",
//           "PPT",
//           "Video",
//         ],
//       ],
//       body: filteredData.map((item, index) => [
//         index + 1,
//         item.title,
//         item.description,
//         item.project_type,
//         item.stud_id?.full_name || "N/A",
//         item.stud_id?.institution || "N/A",
//         item.name_of_group || "N/A",
//         item.number_of_member || "Single",
//         item.idea || "N/A",
//         item.ppt || "Not Available",
//         item.video_file || "Not Available",
//       ]),
//     });

//     doc.save("Projects.pdf");
//   };

//   const renderTable = () => {
//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

//     return (
//       <TableBody>
//         {currentData.map((row, index) => (
//           <StyledTableRow key={row.id}>
//             <TableCell padding="checkbox">
//               <Checkbox
//                 checked={selectedRows.includes(row.stud_id)}
//                 onChange={() => handleRowSelect(row.stud_id)}
//               />
//             </TableCell>
//             <TableCell>{startIndex + index + 1}</TableCell>
//             <TableCell>{row.title}</TableCell>
//             <TableCell>{row.description}</TableCell>
//             <TableCell>{row.project_type}</TableCell>
//             <TableCell>{row.stud_id?.full_name || "N/A"}</TableCell>
//             <TableCell>{row.stud_id?.institution || "N/A"}</TableCell>
//             <TableCell>{new Date(row.created_at).toLocaleDateString()}</TableCell>
//             <TableCell align="center">
//               {row.idea ? (
//                 <a href={row.idea} target="_blank" rel="noopener noreferrer">
//                   View Idea
//                 </a>
//               ) : (
//                 "No Idea"
//               )}
//             </TableCell>
//           </StyledTableRow>
//         ))}
//       </TableBody>
//     );
//   };

//   return (
//     <Box sx={{ margin: "70px", padding: "20px", textAlign: "center" }}>
//       <Typography
//         variant="h4"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           color: "#37474f",
//           textAlign: "center",
//         }}
//       >
//         Shortlisting Projects
//       </Typography>

//       <Box
//         sx={{
//           marginBottom: "20px",
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         <IconButton onClick={fetchData} color="primary">
//           <RefreshIcon />
//         </IconButton>
//         <Box>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleDownloadExcel}
//             sx={{ marginRight: 2 }}
//           >
//             Download Excel
//           </Button>
//           <Button variant="contained" color="secondary" onClick={handleDownloadPDF}>
//             Download PDF
//           </Button>
//         </Box>
//       </Box>

//       <TableContainer
//         component={Paper}
//         sx={{
//           maxWidth: "1000px",
//           margin: "0 auto",
//           backgroundColor: "#E8F4FA",
//           borderRadius: "16px",
//           overflow: "hidden",
//         }}
//       >
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell padding="checkbox">
//                 <Checkbox disabled />
//               </StyledTableCell>
//               <StyledTableCell>Sr. No.</StyledTableCell>
//               <StyledTableCell>Title</StyledTableCell>
//               <StyledTableCell>Description</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               <StyledTableCell>Student Name</StyledTableCell>
//               <StyledTableCell>Institute</StyledTableCell>
//               <StyledTableCell>Created At</StyledTableCell>
//               <StyledTableCell align="center">Idea</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           {renderTable()}
//         </Table>
//       </TableContainer>

//       <Box
//         sx={{
//           margin: "20px auto",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Pagination
//           count={Math.ceil(filteredData.length / rowsPerPage)}
//           page={currentPage}
//           onChange={handlePageChange}
//           color="primary"
//           size="large"
//         />
//         <Button
//           variant="contained"
//           color="success"
//           onClick={handleShortlist}
//           disabled={selectedRows.length === 0}
//         >
//           Shortlist Selected
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default AdminSelected;

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Typography,
//   Checkbox,
//   IconButton,
//   Button,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { Refresh as RefreshIcon } from "@mui/icons-material";
// import axios from "axios";
// import swal from "sweetalert";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 600,
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.selected,
//   },
//   transition: "background-color 0.3s",
// }));

// function AdminSelected() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const rowsPerPage = 5;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const filterData = useCallback(() => {
//     const filtered = data.filter((row) => row.admin_approval === false);
//     setFilteredData(filtered);
//   }, [data]);

//   useEffect(() => {
//     filterData();
//   }, [filterData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowSelect = (stud_id) => {
//     setSelectedRows((prev) =>
//       prev.includes(stud_id)
//         ? prev.filter((id) => id !== stud_id)
//         : [...prev, stud_id]
//     );
//   };

//   const handleShortlist = async () => {
//     try {
//       const response = await axios.patch(
//         "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//         { stud_id: selectedRows }
//       );

//       swal("Success!", response.data.msg, "success");

//       setData((prevData) =>
//         prevData.map((item) =>
//           selectedRows.includes(item.stud_id)
//             ? { ...item, admin_approval: true }
//             : item
//         )
//       );

//       setFilteredData((prevFilteredData) =>
//         prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//       );

//       setSelectedRows([]);
//     } catch (error) {
//       console.error("Error shortlisting projects:", error);
//       swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//     }
//   };

//   // const handleDownloadExcel = () => {
//   //   const excelData = filteredData.map((item, index) => ({
//   //     "Sr. No": index + 1,
//   //     "Project Title": item.title,
//   //     "Description": item.description,
//   //     "Project Type": item.project_type,
//   //     "Student Name": item.stud_id?.full_name || "N/A",
//   //     Email: item.stud_id?.email || "N/A", // Fetch email from stud_id
//   //     "Institute": item.stud_id?.institution || "N/A",
//   //     "Group Name": item.name_of_group || "N/A",
//   //     "Group Members": item.number_of_member || "Single",
//   //     "PDF Link": item.idea
//   //       ? { t: "s", v: "View PDF", l: { Target: item.idea } }
//   //       : "No Idea",
//   //     "PPT Link": item.ppt
//   //       ? { t: "s", v: "View PPT", l: { Target: item.ppt } }
//   //       : "Not Available",
//   //     "Video Link": item.video_file
//   //       ? { t: "s", v: "View Video", l: { Target: item.video_file } }
//   //       : "Not Available",
//   //   }));
  
//   //   // Create worksheet and workbook
//   //   const worksheet = XLSX.utils.json_to_sheet([]);
//   //   XLSX.utils.sheet_add_aoa(
//   //     worksheet,
//   //     [Object.keys(excelData[0])],
//   //     { origin: "A1" }
//   //   );
  
//   //   // Add rows with hyperlinks
//   //   XLSX.utils.sheet_add_json(worksheet, excelData, {
//   //     origin: "A2",
//   //     skipHeader: true,
//   //   });
  
//   //   const workbook = XLSX.utils.book_new();
//   //   XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
  
//   //   // Write the workbook to a file
//   //   XLSX.writeFile(workbook, "Projects.xlsx");
//   // };
  
//   const handleDownloadExcel = () => {
//     const excelData = filteredData.map((item, index) => ({
//       "Sr. No": index + 1,
//       "Project Title": item.title,
//       "Description": item.description,
//       "Project Type": item.project_type,
//       "Student Name": item.stud_id?.full_name || "N/A",
//       "Email": item.stud_id?.email || "N/A", // Fetch email from stud_id
//       "Institute": item.stud_id?.institution || "N/A",
//       "City": item.stud_id?.city || "N/A",
//       "LinkedIn URL": item.stud_id?.linked_url || "N/A",
//       "Phone Number": item.stud_id?.phone_number || "N/A",
//       "Address": item.stud_id?.address || "N/A",
//       "Country": item.stud_id?.country || "N/A",
//       "State": item.stud_id?.state || "N/A",
//       "Gender": item.stud_id?.gender || "N/A",
//       "Graduation Year": item.stud_id?.graduation_year || "N/A",
//       "Graduation Degree": item.stud_id?.graduation_degree || "N/A",
//       "Group Name": item.name_of_group || "N/A",
//       "Group Members": item.number_of_member || "Single",
//       "PDF Link": item.idea
//         ? { t: "s", v: "View PDF", l: { Target: item.idea } }
//         : "No Idea",
//       "PPT Link": item.ppt
//         ? { t: "s", v: "View PPT", l: { Target: item.ppt } }
//         : "Not Available",
//       "Video Link": item.video_file
//         ? { t: "s", v: "View Video", l: { Target: item.video_file } }
//         : "Not Available",
//     }));
  
//     // Create worksheet and workbook
//     const worksheet = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_aoa(worksheet, [Object.keys(excelData[0])], { origin: "A1" });
  
//     // Add rows with hyperlinks
//     XLSX.utils.sheet_add_json(worksheet, excelData, { origin: "A2", skipHeader: true });
  
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
  
//     // Write the workbook to a file
//     XLSX.writeFile(workbook, "Projects.xlsx");
//   };
  
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();

//     doc.text("Projects List", 14, 10);
//     autoTable(doc, {
//       head: [
//         [
//           "Sr. No.",
//           "Project Title",
//           "Description",
//           "Project Type",
//           "Student Name",
//           "Institute",
//           "Group Name",
//           "Group Members",
//           "PDF",
//           "PPT",
//           "Video",
//         ],
//       ],
//       body: filteredData.map((item, index) => [
//         index + 1,
//         item.title,
//         item.description,
//         item.project_type,
//         item.stud_id?.full_name || "N/A",
//         item.stud_id?.institution || "N/A",
//         item.name_of_group || "N/A",
//         item.number_of_member || "Single",
//         item.idea || "N/A",
//         item.ppt || "Not Available",
//         item.video_file || "Not Available",
//       ]),
//     });

//     doc.save("Projects.pdf");
//   };

//   const renderTable = () => {
//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

//     return (
//       <TableBody>
//         {currentData.map((row, index) => (
//           <StyledTableRow key={row.id}>
//             <TableCell padding="checkbox">
//               <Checkbox
//                 checked={selectedRows.includes(row.stud_id)}
//                 onChange={() => handleRowSelect(row.stud_id)}
//               />
//             </TableCell>
//             <TableCell>{startIndex + index + 1}</TableCell>
//             <TableCell>{row.title}</TableCell>
//             <TableCell>{row.description}</TableCell>
//             <TableCell>{row.project_type}</TableCell>
//             <TableCell>{row.stud_id?.full_name || "N/A"}</TableCell>
//             <TableCell>{row.stud_id?.institution || "N/A"}</TableCell>
//             <TableCell>{new Date(row.created_at).toLocaleDateString()}</TableCell>
//             <TableCell align="center">
//               {row.idea ? (
//                 <a href={row.idea} target="_blank" rel="noopener noreferrer">
//                   View Idea
//                 </a>
//               ) : (
//                 "No Idea"
//               )}
//             </TableCell>
//           </StyledTableRow>
//         ))}
//       </TableBody>
//     );
//   };

//   return (
//     <Box sx={{ margin: "70px", padding: "20px", textAlign: "center" }}>
//       <Typography
//         variant="h4"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           color: "#37474f",
//           textAlign: "center",
//         }}
//       >
//         Shortlisting Projects
//       </Typography>

//       <Box
//         sx={{
//           marginBottom: "20px",
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         <IconButton onClick={fetchData} color="primary">
//           <RefreshIcon />
//         </IconButton>
//         <Box>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleDownloadExcel}
//             sx={{ marginRight: 2 }}
//           >
//             Download Excel
//           </Button>
//           <Button variant="contained" color="secondary" onClick={handleDownloadPDF}>
//             Download PDF
//           </Button>
//         </Box>
//       </Box>

//       <TableContainer
//         component={Paper}
//         sx={{
//           maxWidth: "1000px",
//           margin: "0 auto",
//           backgroundColor: "#E8F4FA",
//           borderRadius: "16px",
//           overflow: "hidden",
//         }}
//       >
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell padding="checkbox">
//                 <Checkbox disabled />
//               </StyledTableCell>
//               <StyledTableCell>Sr. No.</StyledTableCell>
//               <StyledTableCell>Title</StyledTableCell>
//               <StyledTableCell>Description</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               <StyledTableCell>Student Name</StyledTableCell>
//               <StyledTableCell>Institute</StyledTableCell>
//               <StyledTableCell>Created At</StyledTableCell>
//               <StyledTableCell align="center">Idea</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           {renderTable()}
//         </Table>
//       </TableContainer>

//       <Box
//         sx={{
//           margin: "20px auto",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Pagination
//           count={Math.ceil(filteredData.length / rowsPerPage)}
//           page={currentPage}
//           onChange={handlePageChange}
//           color="primary"
//           size="large"
//         />
//         <Button
//           variant="contained"
//           color="success"
//           onClick={handleShortlist}
//           disabled={selectedRows.length === 0}
//         >
//           Shortlist Selected
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default AdminSelected;

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Typography,
//   Checkbox,
//   IconButton,
//   Button,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { Refresh as RefreshIcon } from "@mui/icons-material";
// import axios from "axios";
// import swal from "sweetalert";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 600,
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.selected,
//   },
//   transition: "background-color 0.3s",
// }));

// function AdminSelected() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const rowsPerPage = 5;
//       const [loading, setLoading] = useState(false);


//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const filterData = useCallback(() => {
//     const filtered = data.filter((row) => row.admin_approval === false);
//     setFilteredData(filtered);
//   }, [data]);

//   useEffect(() => {
//     filterData();
//   }, [filterData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowSelect = (stud_id) => {
//     setSelectedRows((prev) =>
//       prev.includes(stud_id)
//         ? prev.filter((id) => id !== stud_id)
//         : [...prev, stud_id]
//     );
//   };

//   const handleShortlist = async () => {
//     try {
//       const response = await axios.patch(
//         "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//         { stud_id: selectedRows }
//       );

//       swal("Success!", response.data.msg, "success");

//       setData((prevData) =>
//         prevData.map((item) =>
//           selectedRows.includes(item.stud_id)
//             ? { ...item, admin_approval: true }
//             : item
//         )
//       );

//       setFilteredData((prevFilteredData) =>
//         prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//       );

//       setSelectedRows([]);
//     } catch (error) {
//       console.error("Error shortlisting projects:", error);
//       swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//     }
//   };

  
//   const handleDownloadExcel = () => {
//     const excelData = filteredData.map((item, index) => ({
//       "Sr. No": index + 1,
//       "Project Title": item.title,
//       "Description": item.description,
//       "Project Type": item.project_type,
//       "Student Name": item.stud_id?.full_name || "N/A",
//       "Email": item.stud_id?.email || "N/A", // Fetch email from stud_id
//       "Institute": item.stud_id?.institution || "N/A",
//       "City": item.stud_id?.city || "N/A",
//       "LinkedIn URL": item.stud_id?.linked_url || "N/A",
//       "Phone Number": item.stud_id?.phone_number || "N/A",
//       "Address": item.stud_id?.address || "N/A",
//       "Country": item.stud_id?.country || "N/A",
//       "State": item.stud_id?.state || "N/A",
//       "Gender": item.stud_id?.gender || "N/A",
//       "Graduation Year": item.stud_id?.graduation_year || "N/A",
//       "Graduation Degree": item.stud_id?.graduation_degree || "N/A",
//       "Group Name": item.name_of_group || "N/A",
//       "Group Members": item.number_of_member || "Single",
//       "PDF Link": item.idea
//         ? { t: "s", v: "View PDF", l: { Target: item.idea } }
//         : "No Idea",
//       "PPT Link": item.ppt
//         ? { t: "s", v: "View PPT", l: { Target: item.ppt } }
//         : "Not Available",
//       "Video Link": item.video_file
//         ? { t: "s", v: "View Video", l: { Target: item.video_file } }
//         : "Not Available",
//     }));
  
//     // Create worksheet and workbook
//     const worksheet = XLSX.utils.json_to_sheet([]);
//     XLSX.utils.sheet_add_aoa(worksheet, [Object.keys(excelData[0])], { origin: "A1" });
  
//     // Add rows with hyperlinks
//     XLSX.utils.sheet_add_json(worksheet, excelData, { origin: "A2", skipHeader: true });
  
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
  
//     // Write the workbook to a file
//     XLSX.writeFile(workbook, "Projects.xlsx");
//   };
  
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();

//     doc.text("Projects List", 14, 10);
//     autoTable(doc, {
//       head: [
//         [
//           "Sr. No.",
//           "Project Title",
//           "Description",
//           "Project Type",
//           "Student Name",
//           "Institute",
//           "Group Name",
//           "Group Members",
//           "PDF",
//           "PPT",
//           "Video",
//         ],
//       ],
//       body: filteredData.map((item, index) => [
//         index + 1,
//         item.title,
//         item.description,
//         item.project_type,
//         item.stud_id?.full_name || "N/A",
//         item.stud_id?.institution || "N/A",
//         item.name_of_group || "N/A",
//         item.number_of_member || "Single",
//         item.idea || "N/A",
//         item.ppt || "Not Available",
//         item.video_file || "Not Available",
//       ]),
//     });

//     doc.save("Projects.pdf");
//   };

//   const renderTable = () => {
//     const startIndex = (currentPage - 1) * rowsPerPage;
//     const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

//     return (
//       <TableBody>
//         {currentData.map((row, index) => (
//           <StyledTableRow key={row.id}>
//             <TableCell padding="checkbox">
//               <Checkbox
//                 checked={selectedRows.includes(row.stud_id)}
//                 onChange={() => handleRowSelect(row.stud_id)}
//               />
//             </TableCell>
//             <TableCell>{startIndex + index + 1}</TableCell>
//             <TableCell>{row.title}</TableCell>
//             <TableCell>{row.description}</TableCell>
//             <TableCell>{row.project_type}</TableCell>
//             <TableCell>{row.stud_id?.full_name || "N/A"}</TableCell>
//             <TableCell>{row.stud_id?.institution || "N/A"}</TableCell>
//             <TableCell>{new Date(row.created_at).toLocaleDateString()}</TableCell>
//             <TableCell align="center">
//               {row.idea ? (
//                 <a href={row.idea} target="_blank" rel="noopener noreferrer">
//                   View Idea
//                 </a>
//               ) : (
//                 "No Idea"
//               )}
//             </TableCell>
//           </StyledTableRow>
//         ))}
//       </TableBody>
//     );
//   };

//   return (
//     <Box sx={{ margin: "70px", padding: "20px", textAlign: "center" }}>
//       <Typography
//         variant="h4"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           color: "#37474f",
//           textAlign: "center",
//         }}
//       >
//         Shortlisting Projects
//       </Typography>

//       <Box
//         sx={{
//           marginBottom: "20px",
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         <IconButton onClick={fetchData} color="primary">
//           <RefreshIcon />
//         </IconButton>
//         <Box>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleDownloadExcel}
//             sx={{ marginRight: 2 }}
//           >
//             Download Excel
//           </Button>
//           <Button variant="contained" color="secondary" onClick={handleDownloadPDF}>
//             Download PDF
//           </Button>
//         </Box>
//       </Box>

//       <TableContainer
//         component={Paper}
//         sx={{
//           maxWidth: "1000px",
//           margin: "0 auto",
//           backgroundColor: "#E8F4FA",
//           borderRadius: "16px",
//           overflow: "hidden",
//         }}
//       >
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell padding="checkbox">
//                 <Checkbox disabled />
//               </StyledTableCell>
//               <StyledTableCell>Sr. No.</StyledTableCell>
//               <StyledTableCell>Title</StyledTableCell>
//               <StyledTableCell>Description</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               <StyledTableCell>Student Name</StyledTableCell>
//               <StyledTableCell>Institute</StyledTableCell>
//               <StyledTableCell>Created At</StyledTableCell>
//               <StyledTableCell align="center">Idea</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           {renderTable()}
//         </Table>
//       </TableContainer>

//       <Box
//         sx={{
//           margin: "20px auto",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <Pagination
//           count={Math.ceil(filteredData.length / rowsPerPage)}
//           page={currentPage}
//           onChange={handlePageChange}
//           color="primary"
//           size="large"
//         />
//         <Button
//           variant="contained"
//           color="success"
//           onClick={handleShortlist}
//           disabled={selectedRows.length === 0}
//         >
//           Shortlist Selected
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default AdminSelected;

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Typography,
//   Checkbox,
//   Button,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import axios from "axios";
// import swal from "sweetalert";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 600,
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.selected,
//   },
//   transition: "background-color 0.3s",
// }));

// function AdminSelected() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const rowsPerPage = 5;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const filterData = useCallback(() => {
//     setFilteredData(data.filter((row) => row.admin_approval === false));
//   }, [data]);

//   useEffect(() => {
//     filterData();
//   }, [filterData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowSelect = (stud_id) => {
//     setSelectedRows((prev) =>
//       prev.includes(stud_id)
//         ? prev.filter((id) => id !== stud_id)
//         : [...prev, stud_id]
//     );
//   };

//   const handleShortlist = async () => {
//     try {
//       const response = await axios.patch(
//         "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//         { stud_id: selectedRows }
//       );

//       swal("Success!", response.data.msg, "success");

//       setData((prevData) =>
//         prevData.map((item) =>
//           selectedRows.includes(item.stud_id)
//             ? { ...item, admin_approval: true }
//             : item
//         )
//       );

//       setFilteredData((prevFilteredData) =>
//         prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
//       );

//       setSelectedRows([]);
//     } catch (error) {
//       console.error("Error shortlisting projects:", error);
//       swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//     }
//   };

//   const handleDownloadExcel = () => {
//     const excelData = filteredData.map((item, index) => ({
//       "Sr. No": index + 1,
//       "Project Title": item.title,
//       "Description": item.description,
//       "Project Type": item.project_type,
//       "Student Name": item.stud_id?.full_name || "N/A",
//       "Email": item.stud_id?.email || "N/A",
//       "Institute": item.stud_id?.institution || "N/A",
//       "Group Name": item.name_of_group || "N/A",
//       "Group Members": item.number_of_member || "Single",
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(excelData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
//     XLSX.writeFile(workbook, "Projects.xlsx");
//   };

//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.text("Projects List", 14, 10);
//     autoTable(doc, {
//       head: [["Sr. No.", "Project Title", "Description", "Project Type", "Student Name", "Institute"]],
//       body: filteredData.map((item, index) => [
//         index + 1,
//         item.title,
//         item.description,
//         item.project_type,
//         item.stud_id?.full_name || "N/A",
//         item.stud_id?.institution || "N/A",
//       ]),
//     });
//     doc.save("Projects.pdf");
//   };

//   return (
//     <Box>
//       <Typography variant="h5" gutterBottom>
//         Admin Selected Projects
//       </Typography>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>Select</StyledTableCell>
//               <StyledTableCell>Sr. No</StyledTableCell>
//               <StyledTableCell>Project Title</StyledTableCell>
//               <StyledTableCell>Description</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               <StyledTableCell>Student Name</StyledTableCell>
//               <StyledTableCell>Institute</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((row, index) => (
//               <StyledTableRow key={row.id}>
//                 <TableCell>
//                   <Checkbox checked={selectedRows.includes(row.stud_id)} onChange={() => handleRowSelect(row.stud_id)} />
//                 </TableCell>
//                 <TableCell>{(currentPage - 1) * rowsPerPage + index + 1}</TableCell>
//                 <TableCell>{row.title}</TableCell>
//                 <TableCell>{row.description}</TableCell>
//                 <TableCell>{row.project_type}</TableCell>
//                 <TableCell>{row.stud_id?.full_name || "N/A"}</TableCell>
//                 <TableCell>{row.stud_id?.institution || "N/A"}</TableCell>
//               </StyledTableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Pagination count={Math.ceil(filteredData.length / rowsPerPage)} page={currentPage} onChange={handlePageChange} />
//       <Button onClick={handleShortlist}>Shortlist</Button>
//       <Button onClick={handleDownloadExcel}>Download Excel</Button>
//       <Button onClick={handleDownloadPDF}>Download PDF</Button>
//     </Box>
//   );
// }

// export default AdminSelected;

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Typography,
//   Checkbox,
//   Button,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import axios from "axios";
// import swal from "sweetalert";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 600,
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.selected,
//   },
//   transition: "background-color 0.3s",
// }));

// function AdminSelected() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const rowsPerPage = 5;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const filterData = useCallback(() => {
//     setFilteredData(data.filter((row) => row.admin_approval === false));
//   }, [data]);

//   useEffect(() => {
//     filterData();
//   }, [filterData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowSelect = (studId) => {
//     setSelectedRows((prev) =>
//       prev.includes(studId)
//         ? prev.filter((id) => id !== studId)
//         : [...prev, studId]
//     );
//   };

//   const handleShortlist = async () => {
//     try {
//       const payload = { stud_id: selectedRows };
//       const response = await axios.patch(
//         "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//         payload
//       );

//       swal("Success!", response.data.msg, "success");

//       setData((prevData) =>
//         prevData.map((item) =>
//           selectedRows.includes(item.stud_id.id)
//             ? { ...item, admin_approval: true }
//             : item
//         )
//       );

//       setFilteredData((prevFilteredData) =>
//         prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id.id))
//       );

//       setSelectedRows([]);
//     } catch (error) {
//       console.error("Error shortlisting projects:", error);
//       swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//     }
//   };

//   const handleDownloadExcel = () => {
//     const excelData = filteredData.map((item, index) => ({
//       "Sr. No": index + 1,
//       "Project Title": item.title,
//       "Description": item.description,
//       "Project Type": item.project_type,
//       "Student Name": item.stud_id?.full_name || "N/A",
//       "Email": item.stud_id?.email || "N/A",
//       "Institute": item.stud_id?.institution || "N/A",
//       "Group Name": item.name_of_group || "N/A",
//       "Group Members": item.number_of_member || "Single",
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(excelData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
//     XLSX.writeFile(workbook, "Projects.xlsx");
//   };

//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.text("Projects List", 14, 10);
//     autoTable(doc, {
//       head: [["Sr. No.", "Project Title", "Description", "Project Type", "Student Name", "Institute"]],
//       body: filteredData.map((item, index) => [
//         index + 1,
//         item.title,
//         item.description,
//         item.project_type,
//         item.stud_id?.full_name || "N/A",
//         item.stud_id?.institution || "N/A",
//       ]),
//     });
//     doc.save("Projects.pdf");
//   };

//   return (
//     <Box>
//       <Typography variant="h5" gutterBottom>
//         Admin Selected Projects
//       </Typography>
//       <TableContainer component={Paper}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>Select</StyledTableCell>
//               <StyledTableCell>Sr. No</StyledTableCell>
//               <StyledTableCell>Project Title</StyledTableCell>
//               <StyledTableCell>Description</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               <StyledTableCell>Student Name</StyledTableCell>
//               <StyledTableCell>Institute</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage).map((row, index) => (
//               <StyledTableRow key={row.id}>
//                 <TableCell>
//                   <Checkbox
//                     checked={selectedRows.includes(row.stud_id.id)}
//                     onChange={() => handleRowSelect(row.stud_id.id)}
//                   />
//                 </TableCell>
//                 <TableCell>{(currentPage - 1) * rowsPerPage + index + 1}</TableCell>
//                 <TableCell>{row.title}</TableCell>
//                 <TableCell>{row.description}</TableCell>
//                 <TableCell>{row.project_type}</TableCell>
//                 <TableCell>{row.stud_id?.full_name || "N/A"}</TableCell>
//                 <TableCell>{row.stud_id?.institution || "N/A"}</TableCell>
//               </StyledTableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Pagination count={Math.ceil(filteredData.length / rowsPerPage)} page={currentPage} onChange={handlePageChange} />
//       <Button onClick={handleShortlist}>Shortlist</Button>
//       <Button onClick={handleDownloadExcel}>Download Excel</Button>
//       <Button onClick={handleDownloadPDF}>Download PDF</Button>
//     </Box>
//   );
// }

// export default AdminSelected;

// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Pagination,
//   Typography,
//   Checkbox,
//   Button,
//   useTheme,
//   useMediaQuery,
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import axios from "axios";
// import swal from "sweetalert";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";

// const StyledTableCell = styled(TableCell)(({ theme }) => ({
//   fontWeight: 600,
//   backgroundColor: theme.palette.primary.main,
//   color: theme.palette.common.white,
// }));

// const StyledTableRow = styled(TableRow)(({ theme }) => ({
//   "&:nth-of-type(odd)": {
//     backgroundColor: theme.palette.action.hover,
//   },
//   "&:hover": {
//     backgroundColor: theme.palette.action.selected,
//   },
//   transition: "background-color 0.3s",
// }));

// function AdminSelected() {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [data, setData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const rowsPerPage = 5;
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
//       );
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   const filterData = useCallback(() => {
//     setFilteredData(data.filter((row) => row.admin_approval === false));
//   }, [data]);

//   useEffect(() => {
//     filterData();
//   }, [filterData]);

//   const handlePageChange = (event, page) => {
//     setCurrentPage(page);
//   };

//   const handleRowSelect = (studId) => {
//     setSelectedRows((prev) =>
//       prev.includes(studId)
//         ? prev.filter((id) => id !== studId)
//         : [...prev, studId]
//     );
//   };

//   const handleShortlist = async () => {
//     try {
//       const payload = { stud_id: selectedRows };
//       const response = await axios.patch(
//         "https://puneexpobackend.tdtlworld.com/api/approve_project/",
//         payload
//       );

//       swal("Success!", response.data.msg, "success");

//       // Remove the approved projects from the list
//       setFilteredData((prevFilteredData) =>
//         prevFilteredData.filter(
//           (item) => !selectedRows.includes(item.stud_id.id)
//         )
//       );

//       setSelectedRows([]);
//     } catch (error) {
//       console.error("Error shortlisting projects:", error);
//       swal("Error!", "Failed to shortlist projects. Please try again.", "error");
//     }
//   };

//   const handleDownloadExcel = () => {
//     const excelData = filteredData.map((item, index) => ({
//       "Sr. No": index + 1,
//       "Project Title": item.title,
//       "Description": item.description,
//       "Project Type": item.project_type,
//       "Student Name": item.stud_id?.full_name || "N/A",
//       "Email": item.stud_id?.email || "N/A",
//       "Institute": item.stud_id?.institution || "N/A",
//       "Group Name": item.name_of_group || "N/A",
//       "Group Members": item.number_of_member || "Single",
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(excelData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
//     XLSX.writeFile(workbook, "Projects.xlsx");
//   };

//   const handleDownloadPDF = () => {
//     const doc = new jsPDF();
//     doc.text("Projects List", 14, 10);
//     autoTable(doc, {
//       head: [["Sr. No.", "Project Title", "Description", "Project Type", "Student Name", "Institute"]],
//       body: filteredData.map((item, index) => [
//         index + 1,
//         item.title,
//         item.description,
//         item.project_type,
//         item.stud_id?.full_name || "N/A",
//         item.stud_id?.institution || "N/A",
//       ]),
//     });
//     doc.save("Projects.pdf");
//   };

//   return (
//     <Box sx={{ padding: isMobile ? "16px" : "32px", marginTop: isMobile ? "16px" : "32px" }}>
//       <Typography variant="h5" gutterBottom>
//         Admin Selected Projects
//       </Typography>
//       <TableContainer component={Paper} sx={{ marginBottom: "16px" }}>
//         <Table>
//           <TableHead>
//             <TableRow>
//               <StyledTableCell>Select</StyledTableCell>
//               <StyledTableCell>Sr. No</StyledTableCell>
//               <StyledTableCell>Project Title</StyledTableCell>
//               <StyledTableCell>Description</StyledTableCell>
//               <StyledTableCell>Project Type</StyledTableCell>
//               <StyledTableCell>Student Name</StyledTableCell>
//               <StyledTableCell>Institute</StyledTableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {filteredData
//               .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
//               .map((row, index) => (
//                 <StyledTableRow key={row.id}>
//                   <TableCell>
//                     <Checkbox
//                       checked={selectedRows.includes(row.stud_id.id)}
//                       onChange={() => handleRowSelect(row.stud_id.id)}
//                     />
//                   </TableCell>
//                   <TableCell>{(currentPage - 1) * rowsPerPage + index + 1}</TableCell>
//                   <TableCell>{row.title}</TableCell>
//                   <TableCell>{row.description}</TableCell>
//                   <TableCell>{row.project_type}</TableCell>
//                   <TableCell>{row.stud_id?.full_name || "N/A"}</TableCell>
//                   <TableCell>{row.stud_id?.institution || "N/A"}</TableCell>
//                 </StyledTableRow>
//               ))}
//           </TableBody>
//         </Table>
//       </TableContainer>
//       <Pagination
//         count={Math.ceil(filteredData.length / rowsPerPage)}
//         page={currentPage}
//         onChange={handlePageChange}
//         sx={{ marginBottom: "16px" }}
//       />
//       <Box sx={{ display: "flex", gap: "16px" }}>
//         <Button variant="contained" onClick={handleShortlist}>
//           Shortlist
//         </Button>
//         <Button variant="outlined" onClick={handleDownloadExcel}>
//           Download Excel
//         </Button>
//         <Button variant="outlined" onClick={handleDownloadPDF}>
//           Download PDF
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// export default AdminSelected;



import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Typography,
  Checkbox,
  IconButton,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Refresh as RefreshIcon } from "@mui/icons-material";
import axios from "axios";
import swal from "sweetalert";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
  },
  transition: "background-color 0.3s",
}));

function AdminSelected() {
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const rowsPerPage = 5;

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://puneexpobackend.tdtlworld.com/api/get_idea_submission/"
      );
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filterData = useCallback(() => {
    const filtered = data.filter((row) => row.admin_approval === false);
    setFilteredData(filtered);
  }, [data]);

  useEffect(() => {
    filterData();
  }, [filterData]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleRowSelect = (stud_id) => {
    setSelectedRows((prev) =>
      prev.includes(stud_id)
        ? prev.filter((id) => id !== stud_id)
        : [...prev, stud_id]
    );
  };

  const handleShortlist = async () => {
    try {
      const response = await axios.patch(
        "https://puneexpobackend.tdtlworld.com/api/approve_project/",
        { stud_id: selectedRows }
      );

      swal("Success!", response.data.msg, "success");

      setData((prevData) =>
        prevData.map((item) =>
          selectedRows.includes(item.stud_id)
            ? { ...item, admin_approval: true }
            : item
        )
      );

      setFilteredData((prevFilteredData) =>
        prevFilteredData.filter((item) => !selectedRows.includes(item.stud_id))
      );

      setSelectedRows([]);
    } catch (error) {
      console.error("Error shortlisting projects:", error);
      swal("Error!", "Failed to shortlist projects. Please try again.", "error");
    }
  };

  // const handleDownloadExcel = () => {
  //   const excelData = filteredData.map((item, index) => ({
  //     "Sr. No": index + 1,
  //     "Project Title": item.title,
  //     "Description": item.description,
  //     "Project Type": item.project_type,
  //     "Student Name": item.stud_id?.full_name || "N/A",
  //     Email: item.stud_id?.email || "N/A", // Fetch email from stud_id
  //     "Institute": item.stud_id?.institution || "N/A",
  //     "Group Name": item.name_of_group || "N/A",
  //     "Group Members": item.number_of_member || "Single",
  //     "PDF Link": item.idea
  //       ? { t: "s", v: "View PDF", l: { Target: item.idea } }
  //       : "No Idea",
  //     "PPT Link": item.ppt
  //       ? { t: "s", v: "View PPT", l: { Target: item.ppt } }
  //       : "Not Available",
  //     "Video Link": item.video_file
  //       ? { t: "s", v: "View Video", l: { Target: item.video_file } }
  //       : "Not Available",
  //   }));
  
  //   // Create worksheet and workbook
  //   const worksheet = XLSX.utils.json_to_sheet([]);
  //   XLSX.utils.sheet_add_aoa(
  //     worksheet,
  //     [Object.keys(excelData[0])],
  //     { origin: "A1" }
  //   );
  
  //   // Add rows with hyperlinks
  //   XLSX.utils.sheet_add_json(worksheet, excelData, {
  //     origin: "A2",
  //     skipHeader: true,
  //   });
  
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
  
  //   // Write the workbook to a file
  //   XLSX.writeFile(workbook, "Projects.xlsx");
  // };
  
  const handleDownloadExcel = () => {
    const excelData = filteredData.map((item, index) => ({
      "Sr. No": index + 1,
      "Project Title": item.title,
      "Description": item.description,
      "Project Type": item.project_type,
      "Student Name": item.stud_id?.full_name || "N/A",
      "Email": item.stud_id?.email || "N/A", // Fetch email from stud_id
      "Institute": item.stud_id?.institution || "N/A",
      "City": item.stud_id?.city || "N/A",
      "LinkedIn URL": item.stud_id?.linked_url || "N/A",
      "Phone Number": item.stud_id?.phone_number || "N/A",
      "Address": item.stud_id?.address || "N/A",
      "Country": item.stud_id?.country || "N/A",
      "State": item.stud_id?.state || "N/A",
      "Gender": item.stud_id?.gender || "N/A",
      "Graduation Year": item.stud_id?.graduation_year || "N/A",
      "Graduation Degree": item.stud_id?.graduation_degree || "N/A",
      "Group Name": item.name_of_group || "N/A",
      "Group Members": item.number_of_member || "Single",
      "PDF Link": item.idea
        ? { t: "s", v: "View PDF", l: { Target: item.idea } }
        : "No Idea",
      "PPT Link": item.ppt
        ? { t: "s", v: "View PPT", l: { Target: item.ppt } }
        : "Not Available",
      "Video Link": item.video_file
        ? { t: "s", v: "View Video", l: { Target: item.video_file } }
        : "Not Available",
    }));
  
    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(worksheet, [Object.keys(excelData[0])], { origin: "A1" });
  
    // Add rows with hyperlinks
    XLSX.utils.sheet_add_json(worksheet, excelData, { origin: "A2", skipHeader: true });
  
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
  
    // Write the workbook to a file
    XLSX.writeFile(workbook, "Projects.xlsx");
  };
  
  const handleDownloadPDF = () => {
    const doc = new jsPDF();

    doc.text("Projects List", 14, 10);
    autoTable(doc, {
      head: [
        [
          "Sr. No.",
          "Project Title",
          "Description",
          "Project Type",
          "Student Name",
          "Institute",
          "Group Name",
          "Group Members",
          "PDF",
          "PPT",
          "Video",
        ],
      ],
      body: filteredData.map((item, index) => [
        index + 1,
        item.title,
        item.description,
        item.project_type,
        item.stud_id?.full_name || "N/A",
        item.stud_id?.institution || "N/A",
        item.name_of_group || "N/A",
        item.number_of_member || "Single",
        item.idea || "N/A",
        item.ppt || "Not Available",
        item.video_file || "Not Available",
      ]),
    });

    doc.save("Projects.pdf");
  };

  const renderTable = () => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

    return (
      <TableBody>
        {currentData.map((row, index) => (
          <StyledTableRow key={row.id}>
            <TableCell padding="checkbox">
              <Checkbox
                checked={selectedRows.includes(row.stud_id)}
                onChange={() => handleRowSelect(row.stud_id)}
              />
            </TableCell>
            <TableCell>{startIndex + index + 1}</TableCell>
            <TableCell>{row.title}</TableCell>
            <TableCell>{row.description}</TableCell>
            <TableCell>{row.project_type}</TableCell>
            <TableCell>{row.stud_id?.full_name || "N/A"}</TableCell>
            <TableCell>{row.stud_id?.institution || "N/A"}</TableCell>
            <TableCell>{new Date(row.created_at).toLocaleDateString()}</TableCell>
            <TableCell align="center">
              {row.idea ? (
                <a href={row.idea} target="_blank" rel="noopener noreferrer">
                  View Idea
                </a>
              ) : (
                "No Idea"
              )}
            </TableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    );
  };

  return (
    <Box sx={{ margin: "70px", padding: "20px", textAlign: "center" }}>
      <Typography
        variant="h4"
        sx={{
          mb: 4,
          fontWeight: "bold",
          color: "#37474f",
          textAlign: "center",
        }}
      >
        Shortlisting Projects
      </Typography>

      <Box
        sx={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <IconButton onClick={fetchData} color="primary">
          <RefreshIcon />
        </IconButton>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownloadExcel}
            sx={{ marginRight: 2 }}
          >
            Download Excel
          </Button>
          <Button variant="contained" color="secondary" onClick={handleDownloadPDF}>
            Download PDF
          </Button>
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        sx={{
          maxWidth: "1000px",
          margin: "0 auto",
          backgroundColor: "#E8F4FA",
          borderRadius: "16px",
          overflow: "hidden",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell padding="checkbox">
                <Checkbox disabled />
              </StyledTableCell>
              <StyledTableCell>Sr. No.</StyledTableCell>
              <StyledTableCell>Title</StyledTableCell>
              <StyledTableCell>Description</StyledTableCell>
              <StyledTableCell>Project Type</StyledTableCell>
              <StyledTableCell>Student Name</StyledTableCell>
              <StyledTableCell>Institute</StyledTableCell>
              <StyledTableCell>Created At</StyledTableCell>
              <StyledTableCell align="center">Idea</StyledTableCell>
            </TableRow>
          </TableHead>
          {renderTable()}
        </Table>
      </TableContainer>

      <Box
        sx={{
          margin: "20px auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Pagination
          count={Math.ceil(filteredData.length / rowsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          size="large"
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleShortlist}
          disabled={selectedRows.length === 0}
        >
          Shortlist Selected
        </Button>
      </Box>
    </Box>
  );
}

export default AdminSelected;